var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[(_vm.banners.secondMonthPayment)?_c('second-month-payment-banner'):_vm._e(),_c('div',{staticClass:"mt-3 tabs-container"},[_c('div',{staticClass:"tabs-wrapper"},[_c('main-tabs'),_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }